import React from 'react';
import styled from 'styled-components';
import { FiltersRow } from 'src/components/widgets/filters';
import { Section } from 'src/components/widgets/section';
import { SectionContent } from 'src/components/widgets/section/sectionContent';
import { SkeletonBlock } from 'src/components/widgets/skeleton';
import Stack from 'src/components/widgets/stack/stack';
import { T } from 'src/shared/helpers';
import { ReportOverviewSkeleton } from './reportUI';

const FilterSection = styled(Section)`
    ${SectionContent} {
        padding: 16px;
    }
`;
const FilterPlaceholders = styled(FiltersRow)`
    margin-bottom: 0;
    gap: 12px;
    > div:first-child {
        flex: 1 1 720px;
        gap: 12px;
        > * {
            flex: 1 1 130px;
        }
    }
`;

export default function ReportAISkeleton() {
    return (
        <Stack $gap='16px' aria-busy='true' aria-label={T._('Loading report', 'Admin')}>
            <FilterSection>
                <FilterPlaceholders right={<SkeletonBlock $height='32px' $width='250px' />}>
                    {Array.from({ length: 5 }, (_, index) => (
                        <SkeletonBlock key={index} $height='50px' $width='140px' />
                    ))}
                </FilterPlaceholders>
            </FilterSection>
            <SkeletonBlock $height='32px' $width='100%' />
            <ReportOverviewSkeleton />
        </Stack>
    );
}
